export default __webpack_public_path__ + "static/media/ecology-completed.d0373b76.png";